import {FC} from 'react'
import NumberFormat from 'react-number-format'
import replace from 'lodash/replace'

interface Props {
  onChangePrice: (val: any) => void
  price: number | any
}

export const CreateCustomRate: FC<Props> = ({onChangePrice, price}) => {
  const handleChange = (e: any) => {
    let {value} = e.target
    value = replace(value, '$', '')
    onChangePrice(value)
  }

  return (
    <>
      <label className='form-label fs-6 fw-bold text-dark required'>Custom Shipping Rate</label>
      <NumberFormat
        className='form-control'
        allowNegative={false}
        name='customRate'
        onChange={handleChange}
        placeholder='$0.0'
        prefix='$'
        decimalScale={2}
      />
    </>
  )
}
export default CreateCustomRate
